import { http } from '@/app/lib/http/client'

// 1. Interfaz Principal (Como viene de la base de datos/API)
export interface UnitItem {
    id: number
    name: string
    abbreviation: string
    created_at?: string
    updated_at?: string
}

// 2. Interfaz para Crear (Lo que mandas en el POST)
export interface CreateUnitPayload {
    name: string
    abbreviation?: string
}

// 3. Interfaz para Editar (Lo que mandas en el PUT, usualmente opcional)
export interface UpdateUnitPayload {
    name?: string
    abbreviation?: string
}

// 4. El Objeto de Servicio con todas las peticiones
export const unitService = {
    // Obtener todos (con paginación/búsqueda opcional)
    async getItems(params?: { per_page?: number; search?: string; page?: number }) {
        const response = await http.get('/units', { params }) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Obtener uno solo por ID
    async getItem(id: number) {
        const response = await http.get(`/units/${id}`) // TODO: CAMBIAR RUTA
        return response.data
    },

    // Crear
    async createItem(payload: CreateUnitPayload) {
        const response = await http.post('/units', payload)
        return response.data
    },

    // Actualizar
    async updateItem(id: number, payload: UpdateUnitPayload) {
        const response = await http.put(`/units/${id}`, payload)
        return response.data
    },

    // Eliminar
    async deleteItem(id: number) {
        const response = await http.delete(`/units/${id}`)
        return response.data
    },
}
